import React, {useContext, useEffect, useState} from "react";
import {useHistory} from "react-router";
import {goVehisService} from "../../utils/axios";
import AppToaster from "../../components/AppToaster";
import {SellerContext} from "../../context/seller-context";
import SellerCodeReader from "../../utils/SellerCodeReader";
import Validator from "../../utils/Validator";
import analyitics from "../../utils/analytics";
import noOffersCar from "../../assets/images/content/no-offers-car.png";
import arrowRight from "../../assets/images/icons/arrow_circle_right_white.svg";
import arrowRightBlue from "../../assets/images/icons/arrow_right_blue.svg";

const FINANCING_OPTIONS = [
    "Leasing",
    "Kredyt",
    "Wynajem długoterminowy",
    "Gotówka",
];

function NoOffersFound({ locationPathname }) {
    const history = useHistory();
    const seller = useContext(SellerContext);
    const sellerCodeReader = new SellerCodeReader();

    const [form, setForm] = useState({
        name: "",
        phone: "",
        message: "",
        marketingElectronic: false,
        marketingPhone: false,
        sourceUrl: window.location.href,
        sellerEmail: seller.email,
        sellerPhone: seller.phone,
        sellerCode: sellerCodeReader.readSellerCode(),
    });
    const [submitted, setSubmitted] = useState(false);

    useEffect(() => {
        setForm(prev => ({
            ...prev,
            sellerEmail: seller.email,
            sellerPhone: seller.phone,
            sellerCode: sellerCodeReader.readSellerCode(),
        }));
    }, [seller]);

    useEffect(() => {
        if (Validator.nonNumbersExistsInString(form.phone)) {
            setForm(prev => ({ ...prev, phone: form.phone.slice(0, -1) }));
        }
    }, [form.phone]);

    const valueChangeHandler = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const checkboxChangeHandler = (e) => {
        const { name, checked } = e.target;
        setForm(prev => ({ ...prev, [name]: checked }));
    };

    const submitHandler = (e) => {
        e.preventDefault();
        goVehisService.post("/sellers/contact", form)
            .then(response => {
                AppToaster.show({ message: response.data, intent: "primary" });
                analyitics.sendEvent({ category: 'Kontakt', action: 'Brak ofert – wysłanie formularza' });
                setSubmitted(true);
            })
            .catch(() => {
                AppToaster.show({ message: "Ups! Wystąpił jakiś błąd. Spróbuj ponownie.", intent: "danger" });
            });
    };

    return (
        <div className="no-offers-found">

            {/* ── Komunikat ── */}
            <div className="no-offers-komunikat">
                <img src={noOffersCar} alt="" className="no-offers-car-img" />
                <div className="no-offers-komunikat-content">
                    <p className="no-offers-title">
                        Nie znaleźliśmy ofert<br />spełniających te kryteria
                    </p>
                    <button
                        className="no-offers-back-btn"
                        onClick={() => history.push(locationPathname || "/oferty")}
                    >
                        <img src={arrowRightBlue} alt="" className="no-offers-back-icon no-offers-back-icon--prev" />
                        Wróć do listy ofert
                    </button>
                </div>
            </div>

            {/* ── Formularz kontaktowy ── */}
            <div className="no-offers-form-section">
                <p className="no-offers-form-heading">
                    Nie znalazłeś interesującego auta?<br />
                    Zostaw kontakt – znajdziemy je dla Ciebie
                </p>

                {submitted ? (
                    <p className="no-offers-success">Dziękujemy! Odezwiemy się wkrótce.</p>
                ) : (
                    <form className="no-offers-form" onSubmit={submitHandler}>
                        <div className="no-offers-form-row">
                            <div className="no-offers-form-field">
                                <label className="no-offers-form-label">Imię</label>
                                <input
                                    className="no-offers-form-input"
                                    required
                                    type="text"
                                    name="name"
                                    value={form.name}
                                    onChange={valueChangeHandler}
                                    placeholder=""
                                />
                            </div>
                            <div className="no-offers-form-field">
                                <label className="no-offers-form-label">Nr telefonu</label>
                                <input
                                    className="no-offers-form-input"
                                    required
                                    type="text"
                                    name="phone"
                                    minLength="9"
                                    maxLength="9"
                                    pattern="[0-9]{9}"
                                    value={form.phone}
                                    onChange={valueChangeHandler}
                                    placeholder=""
                                />
                            </div>
                        </div>
                        <div className="no-offers-form-row">
                            <div className="no-offers-form-field">
                                <label className="no-offers-form-label">Forma finansowania</label>
                                <div className="no-offers-select-wrapper">
                                    <select
                                        className={"no-offers-form-input no-offers-form-select" + (form.message === "" ? " no-offers-form-select--placeholder" : "")}
                                        name="message"
                                        value={form.message}
                                        onChange={valueChangeHandler}
                                    >
                                        <option value="">Wybierz</option>
                                        {FINANCING_OPTIONS.map(opt => (
                                            <option key={opt} value={opt}>{opt}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="no-offers-form-field">
                                <label className="no-offers-form-label">Budżet (zł)</label>
                                <input
                                    className="no-offers-form-input"
                                    type="text"
                                    name="budget"
                                    value={form.budget || ""}
                                    onChange={valueChangeHandler}
                                    placeholder=""
                                />
                            </div>
                        </div>

                        <div className="contact-form-consents">
                            <p className="contact-form-consent-text">
                                Przesłanie formularza oznacza wyrażenie zgody na przetwarzanie moich danych osobowych
                                w celu umożliwienia kontaktu drogą telefoniczną lub/i elektroniczną.
                                Więcej informacji o przetwarzaniu danych osobowych i wycofaniu zgody{" "}
                                <a href="/rodo" target="_blank" rel="noreferrer">tutaj.</a>
                            </p>
                            <div className="search-checkbox-row">
                                <input
                                    type="checkbox"
                                    id="no-offers-electronic"
                                    name="marketingElectronic"
                                    checked={form.marketingElectronic}
                                    onChange={checkboxChangeHandler}
                                />
                                <label htmlFor="no-offers-electronic">
                                    Wyrażam zgodę na otrzymywanie informacji marketingowych za pomocą środków
                                    komunikacji elektronicznej. Więcej informacji{" "}
                                    <a href="https://go-leasing.pl/polityka-prywatnosci/" target="_blank" rel="noreferrer">tutaj</a>.
                                </label>
                            </div>
                            <div className="search-checkbox-row">
                                <input
                                    type="checkbox"
                                    id="no-offers-phone"
                                    name="marketingPhone"
                                    checked={form.marketingPhone}
                                    onChange={checkboxChangeHandler}
                                />
                                <label htmlFor="no-offers-phone">
                                    Wyrażam zgodę na otrzymywanie informacji marketingowych przy użyciu
                                    telekomunikacyjnych urządzeń końcowych oraz automatycznych systemów wywołujących.
                                    Więcej informacji{" "}
                                    <a href="https://go-leasing.pl/polityka-prywatnosci/" target="_blank" rel="noreferrer">tutaj</a>.
                                </label>
                            </div>
                        </div>

                        <button type="submit" className="contact-form-submit">
                            wyślij
                            <img src={arrowRight} alt="" className="contact-form-submit-icon" />
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
}

export default NoOffersFound;
